module.exports = __webpack_public_path__ + "images/9bf9e7c246c192e3c1f0b60657e175fb576d4011b8711056367c3e4820436e3b.svg";